var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileSharing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 43,
    viewBox: "0 0 35 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8947 0C12.4062 0 11.9376 0.196977 11.5922 0.547577L0.539534 11.765C0.194084 12.1156 0 12.5911 0 13.087V35.5217C0 38.6194 2.47422 41.1304 5.52632 41.1304H7.36842C8.38578 41.1304 9.21053 40.2934 9.21053 39.2609C9.21053 38.2283 8.38578 37.3913 7.36842 37.3913H5.52632C4.50896 37.3913 3.68421 36.5543 3.68421 35.5217V14.9565L6.28933 11.2174L11.0526 6.38309L14.7368 3.73913H27.6316C28.649 3.73913 29.4737 4.57617 29.4737 5.6087V11.2174C29.4737 12.2499 30.2984 13.087 31.3158 13.087C32.3332 13.087 33.1579 12.2499 33.1579 11.2174V5.6087C33.1579 2.51111 30.6838 0 27.6316 0H12.8947Z",
    fill: "#555555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8947 14.9565C13.9121 14.9565 14.7368 14.1195 14.7368 13.087V3.73913L11.0526 6.38309V11.2174L12.8947 14.9565Z",
    fill: "#4860AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68421 14.9565H12.8947L11.0526 11.2174H6.28933L3.68421 14.9565Z",
    fill: "#943939"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 43C20.0434 43 22.1053 40.9074 22.1053 38.3261V22.1867L31.3158 20.8513V31.8761C31.0181 31.8148 30.7101 31.7826 30.3947 31.7826C27.8513 31.7826 25.7895 33.8752 25.7895 36.4565C25.7895 39.0378 27.8513 41.1304 30.3947 41.1304C32.9381 41.1304 35 39.0378 35 36.4565V18.6957C35 18.1537 34.7683 17.6384 34.3648 17.2832C33.9614 16.9282 33.4261 16.7682 32.8974 16.845L20.0027 18.7145C19.0951 18.846 18.4211 19.6347 18.4211 20.5652V33.7457C18.1234 33.6843 17.8154 33.6522 17.5 33.6522C14.9566 33.6522 12.8947 35.7448 12.8947 38.3261C12.8947 40.9074 14.9566 43 17.5 43Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSharing);
export default __webpack_public_path__ + "static/media/file-sharing.804aa6bf40db61fd9badf1d085bca289.svg";
export { ForwardRef as ReactComponent };